export const formatPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber.replace(/[^\d]/g, '');

  if (cleaned.startsWith('02')) {
    return cleaned.replace(/(\d{2})(\d{3,4})(\d{4})/, '$1-$2-$3');
  }
  return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
};
